export default {
	bind(el, binding) {
		const color = binding.value;
		const colorClassOrStyleResult = colorClassOrStyle(color);

		if(colorClassOrStyleResult.class) {
			const colorClass = colorClassOrStyleResult.class;
			const colorClassFlipped = colorClass.includes('--text')
					? colorClass.replace('--text', '')
					: colorClass + '--text';
			el.classList.add(colorClassFlipped);
		}
		else if(colorClassOrStyleResult.style) {
			el.style.color = colorClassOrStyleResult.style.color;
		}
	}
};